import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { ProgramPharmaciesAddPage } from '../program-pharmacies-add/program-pharmacies-add';
import { PharmacyProvider } from '../../providers/pharmacy/pharmacy';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-pharmacies',
  templateUrl: 'program-pharmacies.html',
})
export class ProgramPharmaciesPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  exportjson: any[] = [];
  displayedColumns = ['name', 'address', 'province', 'fax_number', 'phone_number', 'pharmacist', 'main_contact','actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private pharmacyProvider: PharmacyProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      this.pharmacyProvider
      .listPharmacies(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((pharmacies) => {
        //console.log('Pharmacies: ', pharmacies);
        this.exportjson = pharmacies;
        this.dataSource = new MatTableDataSource(pharmacies);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program pharmacies view and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Pharmacies'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'pharmacies.xlsx'); // initiate a file download in browser
  }

  addeditPharmacy(pharmacy) {
    this.navCtrl.push(ProgramPharmaciesAddPage, {'pharmacydata': pharmacy});
  }

  deletePharmacy(pharmacyId: string)  {
    //console.log('Delete Pharmacy: ', pharmacyId);
    let confirm = this.alertCtrl.create({
      title: "Delete Pharmacy",
      message:
        "Are you sure you would like to delete this pharmacy?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.pharmacyProvider.deletePharmacy(this.program_id, pharmacyId).then(() => {
              //console.log('Successfully deleted the pharmacy');
            })
            .catch((error) => {
              //console.log('Error deleting pharmacy');
            });
          }
        }
      ]
    });
    confirm.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/program-pharmacies/program-pharmacies.ts